<template>
  <div class="w-full max-w-xl">
    <h2 class="text-xl font-semibold mb-4">Filters</h2>

    <!-- Location Search -->
    <label
      for="map-search"
      class="block text-sm font-medium mb-1 text-secondary"
    >
      Search for a location
    </label>
    <div class="relative">
      <input
        id="map-search"
        v-model="search"
        @keyup.enter="submitSearch"
        type="text"
        placeholder="E.g. Eiffel Tower, New York"
        autocomplete="off"
        class="w-full py-2 pr-11 pl-3 rounded-lg border border-grey-light shadow-sm bg-background text-primary focus:outline-none focus:ring-2 focus:ring-brand-darkblue"
      />
      <button
        @click="submitSearch"
        :disabled="loading"
        aria-label="Search for location"
        class="absolute top-1/2 right-1 -translate-y-1/2 p-2 rounded-md bg-brand-darkblue text-white hover:bg-brand-navy focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M8.5 3a5.5 5.5 0 104.02 9.396l3.553 3.552a.75.75 0 101.06-1.06l-3.553-3.553A5.5 5.5 0 008.5 3zM5 8.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <!-- Category Filter -->
    <label class="block mb-4 mt-4">
      <span class="text-sm text-secondary">Category</span>
      <select
        class="mt-1 w-full p-2 border rounded-xl bg-white shadow-sm focus:ring focus:ring-brand-darkblue"
      >
        <option value="">All</option>
        <option value="office">Warehouse</option>
        <option value="warehouse">Empty Plot</option>
      </select>
    </label>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { defineEmits } from "vue";

// Emit search results
const emit = defineEmits(["location-found"]);

// State
const search = ref("");
const error = ref("");
const loading = ref(false);

// Trigger geocoding request
const submitSearch = async () => {
  error.value = "";
  const trimmed = search.value.trim();
  if (!trimmed) {
    error.value = "Please enter a location to search.";
    return;
  }

  loading.value = true;
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(trimmed)}`,
    );
    const results = await response.json();

    if (results.length > 0) {
      const { lat, lon, display_name } = results[0];
      emit("location-found", {
        coordinates: [parseFloat(lat), parseFloat(lon)],
        popupText: display_name,
      });
    } else {
      error.value = "No results found for that location.";
    }
  } catch (e) {
    console.error(e);
    error.value = "An error occurred while searching. Please try again.";
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped></style>
